import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import isEqual from 'lodash.isequal';

// Global Types
import { AppState } from 'services/types';

// Global Actions
import {
    requestLoadScaffoldData,
    canceledLoadScaffoldData
} from 'services/scaffoldData/actions';

// Global Selectors
import { selectLoadScaffoldDataParams } from 'services/scaffoldData/params';

interface ConnectedProps {
    params?: Record<string, any>;
}

interface DispatchProps {
    requestLoadScaffoldData: Function;
    canceledLoadScaffoldData: Function;
}

type Props = ConnectedProps & DispatchProps;

export class ScaffoldDataRequest extends React.PureComponent<Props> {
    componentDidMount(): void {
        const { props } = this;
        props.requestLoadScaffoldData();
    }

    componentDidUpdate(prevProps: Props): void {
        const { props } = this;
        if (!isEqual(prevProps.params, props.params)) {
            props.requestLoadScaffoldData();
        }
    }

    componentWillUnmount(): void {
        const { props } = this;
        props.canceledLoadScaffoldData();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    params: selectLoadScaffoldDataParams
});

export default connect(
    mapStateToProps,
    {
        requestLoadScaffoldData,
        canceledLoadScaffoldData
    }
)(ScaffoldDataRequest);
